import { countries } from 'platform-data';
import { FeeStatus, IOption } from 'api-paths-cas';

export const formNationalityOptions: IOption[] = countries
  .map(country => ({
    value: country.nationality,
    label: country.nationality,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const formFeeStatusOptions: IOption[] = [
  { value: FeeStatus.Overseas, label: 'Overseas' },
  { value: FeeStatus.Home, label: 'Home' },
  { value: FeeStatus.NotSure, label: 'Not sure' },
];
